import { Icon } from '@innovationnorway/cl-react';
import React from 'react';
import './ValueDifference.scss';
import { useTranslation } from 'react-i18next';
type ValueDifferenceTypes = {
  value: number;
  previousValue: number;
  isPercentage?: boolean;
};
const ValueDifference: React.FC<ValueDifferenceTypes> = ({ value, previousValue, isPercentage }) => {
  const { t: tSiva } = useTranslation('siva');
  const difference = value - previousValue;
  if (difference > 0) {
    return (
      <p className="value-difference">
        <Icon
          prefix="fasr"
          iconName="arrow-up-right"
          className="value-difference__icon--positive"
          aria-label={tSiva('report.goals.positive')}
        />
        {tSiva(isPercentage ? 'report.goals.difference.higherPercentage' : 'report.goals.difference.higher', {
          difference,
        })}
      </p>
    );
  }
  if (difference < 0) {
    return (
      <p className="value-difference">
        <Icon
          prefix="fasr"
          iconName="arrow-down-right"
          className="value-difference__icon--negative"
          aria-label={tSiva('report.goals.negative')}
        />
        {tSiva(isPercentage ? 'report.goals.difference.lowerPercentage' : 'report.goals.difference.lower', {
          difference,
        })}
      </p>
    );
  }
  return (
    <p className="value-difference">
      <Icon
        prefix="fasr"
        iconName="arrow-right"
        className="value-difference__icon"
        aria-label={tSiva('report.goals.unchanged')}
      />
      {tSiva('report.goals.difference.unchanged')}
    </p>
  );
};
export default ValueDifference;
